const darkColors = {
  accent: '#F9BA42',
  accentBg: 'rgba(249,186,66,0.08)',
  accentBorder: 'rgba(249,186,66,0.22)',
  accentDark: '#E0A030',
  accentHighlight: '#FFD166',
  accentInk: '#F9BA42',
  accentRing: 'rgba(249,186,66,0.15)',
  accentShadow: '0 4px 14px rgba(249,186,66,0.20)',
  accentShadowHover: '0 6px 18px rgba(249,186,66,0.28)',
  bg: '#05080F',
  bgCard: '#0A0E1A',
  bgCard2: '#0E1222',
  bgCard3: '#141828',
  bgHover: '#0E1222',
  bgTopbar: '#05080F',
  blue: '#3B82F6',
  border: '#1A2035',
  borderStrong: '#2E3D5C',
  borderSubtle: '#1A2035',
  errorRing: 'rgba(231,77,60,0.07)',
  fieldBg: 'rgba(255,255,255,0.03)',
  fieldBgDisabled: 'rgba(255,255,255,0.01)',
  fieldBgError: 'rgba(231,77,60,0.04)',
  fieldBgFocus: 'rgba(249,186,66,0.04)',
  fieldBorder: 'rgba(255,255,255,0.08)',
  fieldBorderDisabled: 'rgba(255,255,255,0.04)',
  fieldBorderError: 'rgba(231,77,60,0.5)',
  fieldBorderFocus: 'rgba(249,186,66,0.45)',
  fieldBorderHover: 'rgba(255,255,255,0.14)',
  fieldRing: 'rgba(249,186,66,0.07)',
  gold: '#F9BA42',
  green: '#4AB756',
  iconMuted: '#4A6090',
  lightboxBackdrop: 'rgba(5, 8, 15, 0.94)',
  lightboxControl: 'rgba(255,255,255,0.12)',
  lightboxControlHover: 'rgba(255,255,255,0.2)',
  mediaOutline: 'rgba(255,255,255,0.1)',
  onAccent: '#1A1B24',
  orange: '#FFA500',
  red: '#E05C5C',
  scrim: 'rgba(5, 8, 15, 0.72)',
  shadowCard: '0 8px 24px rgba(0,0,0,0.50)',
  shadowStickyColumn: '-10px 0 14px -10px rgba(0,0,0,0.70)',
  skeleton: 'rgba(255,255,255,0.06)',
  teal: '#14B8A6',
  textMuted: '#3A4560',
  textPrimary: '#EEF2FF',
  textSecondary: '#7A8AAF',
  topbarAccent: '#F9BA42',
  topbarAccentBg: 'rgba(249,186,66,0.08)',
  topbarAccentBorder: 'rgba(249,186,66,0.22)',
  topbarBorder: '#1A2035',
  topbarHover: '#141828',
  topbarText: '#EEF2FF',
  topbarTextMuted: '#7A8AAF',
  violet: '#A78BFA',
  white: '#FFFFFF',
} as const;

const lightColors = {
  accent: '#F9BA42',
  accentBg: '#FEF3C7',
  accentBorder: '#FDE68A',
  accentDark: '#E59700',
  accentHighlight: '#FFD166',
  accentInk: '#B45309',
  accentRing: 'rgba(249,186,66,0.15)',
  accentShadow: '0 4px 14px rgba(249,186,66,0.20)',
  accentShadowHover: '0 6px 18px rgba(249,186,66,0.28)',
  bg: '#F4F5F7',
  bgCard: '#FFFFFF',
  bgCard2: '#F9FAFB',
  bgCard3: '#F3F4F6',
  bgHover: '#F9FAFB',
  bgTopbar: '#05080F',
  blue: '#2563EB',
  border: '#E5E7EB',
  borderStrong: '#D1D5DB',
  borderSubtle: '#E5E7EB',
  errorRing: 'rgba(220,38,38,0.07)',
  fieldBg: 'rgba(0,0,0,0.03)',
  fieldBgDisabled: 'rgba(0,0,0,0.01)',
  fieldBgError: 'rgba(220,38,38,0.04)',
  fieldBgFocus: 'rgba(180,83,9,0.04)',
  fieldBorder: 'rgba(0,0,0,0.08)',
  fieldBorderDisabled: 'rgba(0,0,0,0.04)',
  fieldBorderError: 'rgba(220,38,38,0.5)',
  fieldBorderFocus: 'rgba(180,83,9,0.45)',
  fieldBorderHover: 'rgba(0,0,0,0.14)',
  fieldRing: 'rgba(180,83,9,0.07)',
  gold: '#F9BA42',
  green: '#16A34A',
  iconMuted: '#6B7280',
  lightboxBackdrop: 'rgba(15, 23, 42, 0.9)',
  lightboxControl: 'rgba(255,255,255,0.12)',
  lightboxControlHover: 'rgba(255,255,255,0.2)',
  mediaOutline: 'rgba(0,0,0,0.1)',
  onAccent: '#1A1B24',
  orange: '#C2410C',
  red: '#DC2626',
  scrim: 'rgba(244, 245, 247, 0.72)',
  shadowCard: '0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px -1px rgba(0, 0, 0, 0.03)',
  shadowStickyColumn: '-10px 0 14px -10px rgba(15, 23, 42, 0.18)',
  skeleton: 'rgba(0,0,0,0.06)',
  teal: '#0F766E',
  textMuted: '#6B7280',
  textPrimary: '#111827',
  textSecondary: '#4B5563',
  topbarAccent: '#F9BA42',
  topbarAccentBg: 'rgba(249,186,66,0.08)',
  topbarAccentBorder: 'rgba(249,186,66,0.22)',
  topbarBorder: '#1A2035',
  topbarHover: '#141828',
  topbarText: '#EEF2FF',
  topbarTextMuted: '#7A8AAF',
  violet: '#6D28D9',
  white: '#FFFFFF',
} as const;

export type ThemeColorSet = { [K in keyof typeof darkColors]: string };

export const darkThemeColors: ThemeColorSet = darkColors;
export const lightThemeColors: ThemeColorSet = lightColors;
